import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  const navigation = [
    { name: 'Home', href: '/' },
    {
      name: 'Calculators',
      href: '#',
      dropdown: [
        { name: 'Home Loan Calculator', href: '/calculators/home-loan' },
        { name: 'EMI Calculator', href: '/calculators/emi' },
        { name: 'Tax Calculator', href: '/calculators/tax' },
        { name: 'SIP Calculator', href: '/calculators/sip' },
      ]
    },
    {
      name: 'Comparisons',
      href: '#',
      dropdown: [
        { name: 'Credit Cards', href: '/comparisons/credit-cards' },
        { name: 'Loans', href: '/comparisons/loans' },
        { name: 'Insurance', href: '/comparisons/insurance' },
      ]
    },
    {
      name: 'Guides',
      href: '#',
      dropdown: [
        { name: 'Tax Saving Tips', href: '/guides/tax-saving-tips' },
        { name: 'Investment Strategies', href: '/guides/investment-strategies' },
        { name: 'Stock Market Basics', href: '/guides/stock-market-basics' },
      ]
    },
    { name: 'Blog', href: '/blog' },
  ];

  return (
    <nav className="bg-white shadow-lg sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2">
            <div className=" rounded-lg flex items-center justify-center">
              <svg width="24" height="36" viewBox="0 0 15 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <mask id="mask0_3_40" style={{maskType: 'luminance'}} maskUnits="userSpaceOnUse" x="0" y="0" width="15" height="14">
                  <path d="M10.9528 0.0479033C1.88034 1.45971 0 4.99836 0 13.1437C1.02762 9.01794 4.82687 6.40689 11.3978 5.31051C16 4.54262 14.7612 -0.544733 10.9528 0.0479033Z" fill="white" />
                </mask>
                <g mask="url(#mask0_3_40)">
                  <path d="M16 -0.544739H0V13.1437H16V-0.544739Z" fill="url(#paint0_linear_3_40)" />
                </g>
                <mask id="mask1_3_40" style={{maskType: 'luminance'}} maskUnits="userSpaceOnUse" x="0" y="8" width="15" height="14">
                  <path d="M10.9528 8.26813C1.88034 9.67993 0 13.2186 0 21.3639C1.02762 17.2382 4.82687 14.6271 11.3978 13.5307C16 12.7628 14.7612 7.67549 10.953 8.26879" fill="white" />
                </mask>
                <g mask="url(#mask1_3_40)">
                  <path d="M16 7.67548H0V21.3639H16V7.67548Z" fill="url(#paint1_linear_3_40)" />
                </g>
                <mask id="mask2_3_40" style={{maskType: 'luminance'}} maskUnits="userSpaceOnUse" x="0" y="15" width="5" height="9">
                  <path d="M2.3793 23.4557C3.69455 23.4557 4.77054 22.4109 4.77054 21.1338V15.6134C2.21007 16.9873 0.611472 18.9044 0 21.3639C0.12009 22.5338 1.14419 23.4553 2.3793 23.4553" fill="white" />
                </mask>
                <g mask="url(#mask2_3_40)">
                  <path d="M4.77054 15.6134H0V23.4553H4.77054V15.6134Z" fill="url(#paint2_linear_3_40)" />
                </g>
                <defs>
                  <linearGradient id="paint0_linear_3_40" x1="-0.215382" y1="6.79187" x2="12.8427" y2="5.96181" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#080037" />
                    <stop offset="1" stopColor="#14B9E2" />
                  </linearGradient>
                  <linearGradient id="paint1_linear_3_40" x1="0.305162" y1="14.9809" x2="13.3633" y2="14.1508" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#080037" />
                    <stop offset="1" stopColor="#14B9E2" />
                  </linearGradient>
                  <linearGradient id="paint2_linear_3_40" x1="2.04704" y1="23.4243" x2="2.59155" y2="16.7833" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#080037" />
                    <stop offset="1" stopColor="#14B9E2" />
                  </linearGradient>
                </defs>
              </svg>
            </div>
            <span className="text-xl font-bold text-gray-900">Finclify</span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            {navigation.map((item) => (
              <div key={item.name} className="relative group">
                {item.dropdown ? (
                  <>
                    <button className="flex items-center space-x-1 text-gray-700 hover:text-primary-600 font-medium transition-colors">
                      <span>{item.name}</span>
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                      </svg>
                    </button>
                    <div className="absolute top-full left-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50">
                      {item.dropdown.map((dropdownItem) => (
                        <Link
                          key={dropdownItem.name}
                          to={dropdownItem.href}
                          className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-primary-600 transition-colors first:rounded-t-lg last:rounded-b-lg"
                        >
                          {dropdownItem.name}
                        </Link>
                      ))}
                    </div>
                  </>
                ) : (
                  <Link
                    to={item.href}
                    className={`font-medium transition-colors ${isActive(item.href)
                        ? 'text-primary-600'
                        : 'text-gray-700 hover:text-primary-600'
                      }`}
                  >
                    {item.name}
                  </Link>
                )}
              </div>
            ))}
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-700 hover:text-primary-600 focus:outline-none focus:text-primary-600"
            >
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                {isMenuOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 bg-white border-t border-gray-200">
              {navigation.map((item) => (
                <div key={item.name}>
                  {item.dropdown ? (
                    <div className="space-y-1">
                      <div className="text-sm font-medium text-gray-500 px-3 py-2">{item.name}</div>
                      {item.dropdown.map((dropdownItem) => (
                        <Link
                          key={dropdownItem.name}
                          to={dropdownItem.href}
                          onClick={() => setIsMenuOpen(false)}
                          className="block px-6 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-primary-600 transition-colors"
                        >
                          {dropdownItem.name}
                        </Link>
                      ))}
                    </div>
                  ) : (
                    <Link
                      to={item.href}
                      onClick={() => setIsMenuOpen(false)}
                      className={`block px-3 py-2 text-sm font-medium transition-colors ${isActive(item.href)
                          ? 'text-primary-600 bg-primary-50'
                          : 'text-gray-700 hover:text-primary-600 hover:bg-gray-50'
                        }`}
                    >
                      {item.name}
                    </Link>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;